module.exports = __webpack_public_path__ + "static/media/SzenOkLogo.1d9318c0.svg";